export default __webpack_public_path__ + "static/media/google.85707a33.png";